import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";

import { ConsultaPerfil } from '../../funciones/NotificacionesFunction';

class PerfilModalContent extends Component {
    state = {
        contenidoModal:{
            Cedula: "",
            Pasaporte: "",
            NombreC: "", 
            Pais: "",
            Estado: "",
            Ciudad: "",
            Municipio: "",
            Parroquia: "",
            FNac: "",
            Edad: "",
            Etnia: "",
            PaisDir: "",
            EstadoDir: "",
            CiudadDir: "",
            MunicipioDir: "",
            ParroquiaDir: "",
            Avenida: "",
            Casa: "",
            Tlf1: "",
            Tlf2: "",
            Tlf3: "",
        },
        contenidoModalRepre: {
            Cedula: "",
            Pasaporte: "",
            NombreC: "",
            PaisDir: "",
            EstadoDir: "",
            CiudadDir: "",
            MunicipioDir: "",
            ParroquiaDir: "",
            Avenida: "",
            Casa: "",
            Email: "",
            Tlf1: "",
            Tlf2: "",
            Tlf3: "",
        }
    }

    constructor (props) {
        super (props);

        ConsultaPerfil (this.props.id, (resp) => {
            if((resp[0].Edad[0].edad) < 18 ) this.setState({contenidoModalRepre: resp[1]})
            this.setState({contenidoModal: resp[0]})
            this.props.titulo(resp[0].NombreC)
            this.props.idUser(resp[0].Cedula)
        })
    }


    render() {
        const { contenidoModal, contenidoModalRepre } = this.state;
        let Edad = 0;
        let NEdad = "";
        if(contenidoModal.Edad[0] !== undefined) {
            Edad =contenidoModal.Edad[0].edad
            NEdad = contenidoModal.Edad[0].fechaTit.text
        }

        let contentRepre = (edad) => {
            if (edad > 17) return null;
            return (
                <React.Fragment>
                    <Col md ={12} className="custom-mt-10 custom-alert-warning">Datos del Representante</Col>

                    <Col md ={3} className="custom-mt-10 modal-custom-subt">Cédula de Identidad</Col>
                    <Col md ={3} className="custom-mt-10 modal-custom-subt">Pasaporte</Col>
                    <Col md ={6} className="custom-mt-10 modal-custom-subt">Nombre Completo</Col>

                    <Col md ={3} className="custom-mt-10">{contenidoModalRepre.Cedula}</Col>
                    <Col md ={3} className="custom-mt-10">{contenidoModalRepre.Pasaporte}</Col>
                    <Col md ={6} className="custom-mt-10">{contenidoModalRepre.NombreC}</Col>

                    <Col md ={12} className="custom-mt-10 custom-alert-warning">Dirección del Representante</Col>

                    <Col md ={2} className="custom-mt-10 modal-custom-subt">Pais</Col>
                    <Col md ={2} className="custom-mt-10 modal-custom-subt">Estado</Col>
                    <Col md ={2} className="custom-mt-10 modal-custom-subt">Ciudad</Col>
                    <Col md ={3} className="custom-mt-10 modal-custom-subt">Municipio</Col>
                    <Col md ={3} className="custom-mt-10 modal-custom-subt">Parroquia</Col>

                    <Col md ={2} className="custom-mt-10">{contenidoModalRepre.PaisDir}</Col>
                    <Col md ={2} className="custom-mt-10">{contenidoModalRepre.EstadoDir}</Col>
                    <Col md ={2} className="custom-mt-10">{contenidoModalRepre.CiudadDir}</Col>
                    <Col md ={3} className="custom-mt-10">{contenidoModalRepre.MunicipioDir}</Col>
                    <Col md ={3} className="custom-mt-10">{contenidoModalRepre.ParroquiaDir}</Col>

                    <Col md ={6} className="custom-mt-10 modal-custom-subt">Avenida/Calle</Col>
                    <Col md ={6} className="custom-mt-10 modal-custom-subt">Edif./Casa</Col>
                    
                    <Col md ={6} className="custom-mt-10">{contenidoModalRepre.Avenida}</Col>
                    <Col md ={6} className="custom-mt-10">{contenidoModalRepre.Casa}</Col>

                    <Col md ={12} className="custom-mt-10 modal-custom-subt">Correo Electrónico</Col>
                    <Col md ={12} className="custom-mt-10">{contenidoModalRepre.Email}</Col>

                    <Col md ={4} className="custom-mt-10 modal-custom-subt">Tlf. Habitación</Col>
                    <Col md ={4} className="custom-mt-10 modal-custom-subt">Tlf. Celular</Col>
                    <Col md ={4} className="custom-mt-10 modal-custom-subt">Tlf. Oficina</Col>

                    <Col md ={4} className="custom-mt-10">{contenidoModalRepre.Tlf1}</Col>
                    <Col md ={4} className="custom-mt-10">{contenidoModalRepre.Tlf2}</Col>
                    <Col md ={4} className="custom-mt-10">{contenidoModalRepre.Tlf3}</Col>
                </React.Fragment>
            )
        }

        return (
            <Row style={{position:"inherit", overflowY :"auto", height:"60vh", padding:10}}>
                <Col md ={12} className="custom-mt-10 custom-alert-info">Datos Personales</Col>

                <Col md ={3} className="custom-mt-10 modal-custom-subt">Cédula de Identidad</Col>
                <Col md ={3} className="custom-mt-10 modal-custom-subt">Pasaporte</Col>
                <Col md ={6} className="custom-mt-10 modal-custom-subt">Nombre Completo</Col>

                <Col md ={3} className="custom-mt-10">{contenidoModal.Cedula}</Col>
                <Col md ={3} className="custom-mt-10">{contenidoModal.Pasaporte}</Col>
                <Col md ={6} className="custom-mt-10">{contenidoModal.NombreC}</Col>

                <Col md ={12} className="custom-mt-10 custom-alert-info">Datos de Nacimiento</Col>

                <Col md ={2} className="custom-mt-10 modal-custom-subt">Pais</Col>
                <Col md ={2} className="custom-mt-10 modal-custom-subt">Estado</Col>
                <Col md ={2} className="custom-mt-10 modal-custom-subt">Ciudad</Col>
                <Col md ={3} className="custom-mt-10 modal-custom-subt">Municipio</Col>
                <Col md ={3} className="custom-mt-10 modal-custom-subt">Parroquia</Col>

                <Col md ={2} className="custom-mt-10">{contenidoModal.Pais}</Col>
                <Col md ={2} className="custom-mt-10">{contenidoModal.Estado}</Col>
                <Col md ={2} className="custom-mt-10">{contenidoModal.Ciudad}</Col>
                <Col md ={3} className="custom-mt-10">{contenidoModal.Municipio}</Col>
                <Col md ={3} className="custom-mt-10">{contenidoModal.Parroquia}</Col>

                <Col md ={3} className="custom-mt-10 modal-custom-subt">Fecha de Nacimiento</Col>
                <Col md ={3} className="custom-mt-10 modal-custom-subt">Etnia</Col>
                <Col md ={6} className="custom-mt-10 modal-custom-subt">Edad</Col>

                <Col md ={3} className="custom-mt-10">{contenidoModal.FNac}</Col>
                <Col md ={3} className="custom-mt-10">{contenidoModal.Etnia}</Col>
                <Col md ={6} className="custom-mt-10">{NEdad}</Col>

                <Col md ={12} className="custom-mt-10 custom-alert-info">Dirección de Habitación</Col>

                <Col md ={2} className="custom-mt-10 modal-custom-subt">Pais</Col>
                <Col md ={2} className="custom-mt-10 modal-custom-subt">Estado</Col>
                <Col md ={2} className="custom-mt-10 modal-custom-subt">Ciudad</Col>
                <Col md ={3} className="custom-mt-10 modal-custom-subt">Municipio</Col>
                <Col md ={3} className="custom-mt-10 modal-custom-subt">Parroquia</Col>

                <Col md ={2} className="custom-mt-10">{contenidoModal.PaisDir}</Col>
                <Col md ={2} className="custom-mt-10">{contenidoModal.EstadoDir}</Col>
                <Col md ={2} className="custom-mt-10">{contenidoModal.CiudadDir}</Col>
                <Col md ={3} className="custom-mt-10">{contenidoModal.MunicipioDir}</Col>
                <Col md ={3} className="custom-mt-10">{contenidoModal.ParroquiaDir}</Col>

                <Col md ={6} className="custom-mt-10 modal-custom-subt">Avenida/Calle</Col>
                <Col md ={6} className="custom-mt-10 modal-custom-subt">Edif./Casa</Col>
                
                <Col md ={6} className="custom-mt-10">{contenidoModal.Avenida}</Col>
                <Col md ={6} className="custom-mt-10">{contenidoModal.Casa}</Col>

                <Col md ={4} className="custom-mt-10 modal-custom-subt">Tlf. Habitación</Col>
                <Col md ={4} className="custom-mt-10 modal-custom-subt">Tlf. Celular</Col>
                <Col md ={4} className="custom-mt-10 modal-custom-subt">Tlf. Oficina</Col>

                <Col md ={4} className="custom-mt-10">{contenidoModal.Tlf1}</Col>
                <Col md ={4} className="custom-mt-10">{contenidoModal.Tlf2}</Col>
                <Col md ={4} className="custom-mt-10">{contenidoModal.Tlf3}</Col>

                {contentRepre(Edad)}
            </Row>
        );
    }
}
 
export default PerfilModalContent;


// WEBPACK FOOTER //
// ./src/views/Perfil/PerfilModalContent.jsx